import { BlobResponse } from "../httpClients/clients/http.client";

export function downloadBlob({ blob, filename }: BlobResponse, fallbackFilename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename ?? fallbackFilename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
